export default __webpack_public_path__ + "static/media/hash.76681cb0.svg";